import React from "react";
import "./sidedraw.css";

function Sidedraw({ children }) {
  return (
    <div className="sidedraw w-14 h-full">
      <ul className="space-y-3.5 flex flex-col items-center py-7">{children}</ul>
    </div>
  );
}

export default Sidedraw;
